module.exports = __webpack_public_path__ + "img/complete.ef19f97d.svg";